import React, { useState } from "react";
import { useIntl } from "react-intl";
import clsx from "clsx";
import { toast } from "react-toastify";

import { ClickableComponent } from "@app/core";

import { FormGroup } from "@app/core/form-group/form-group";
import { FormRow } from "@app/core/form-row/form-row";
import { FormField } from "@app/core/form-field/form-field";
import styles from "./css-sync.module.scss";

import { syncGoogleContent } from "./google-content-api";

const CssSync = () => {
  const intl = useIntl();

  const [syncStatus, setSyncStatus] = useState<"idle" | "syncing" | "success" | "error">("idle");

  const handleCssSync = async () => {
    setSyncStatus("syncing");
    const result = await syncGoogleContent();
    setSyncStatus(result.type);

    if (result.type === "success") {
      toast.success(result.message || intl.formatMessage({ id: "cssSync.sync.alert.success" }));
    } else {
      toast.error(result.message || intl.formatMessage({ id: "cssSync.sync.alert.error" }));
    }
  };

  return (
    <div className={styles.css}>
      <div className={styles.topBar}>
        <div className={clsx(styles.container, styles.topBarContainer)}>
          <div className={styles.topBarLeft}>
            <h2>{intl.formatMessage({ id: "cssSync.title" })}</h2>
          </div>
        </div>
      </div>

      <div className={styles.container}>
        <div className={styles.details}>
          <FormGroup title={intl.formatMessage({ id: "cssSync.sync.title" })} hideSeparator marginBottom={0}>
            <FormRow>
              <FormField>
                <p>{intl.formatMessage({ id: "cssSync.sync.description" })}</p>
                <ClickableComponent
                  buttonType="button"
                  title={
                    syncStatus === "syncing"
                      ? intl.formatMessage({ id: "cssSync.sync.button.loading" })
                      : syncStatus === "error"
                      ? intl.formatMessage({ id: "cssSync.sync.button.error" })
                      : syncStatus === "success"
                      ? intl.formatMessage({ id: "cssSync.sync.button.success" })
                      : intl.formatMessage({ id: "cssSync.sync.button.title" })
                  }
                  onClick={handleCssSync}
                  disabled={syncStatus !== "idle"}
                />
              </FormField>
            </FormRow>
          </FormGroup>
        </div>
      </div>
    </div>
  );
};

export { CssSync };
